/*
 * IS_STAGING and IS_DEV might be redundant...
 * They have been included to clarify the logic distinguishing environments
 * And in case they may be useful going forward
 */

// is TRUE on tdc.gatsbyjs.io, beta.tdc.dk, tdcdk-beta-staging.public.lqd.dk and tdc.dk
export const IS_PROD: boolean = process.env.NODE_ENV === 'production' && !process.env.GATSBY_STAGING

// is TRUE on https://tdcdk-staging.netlify.app/, contentful preview, PR gatsby builds
export const IS_STAGING: boolean = process.env.NODE_ENV === 'production' && !!process.env.GATSBY_STAGING

// is TRUE when running gatsby develop
export const IS_DEV: boolean = process.env.NODE_ENV === 'development'

// is TRUE if its localhost
export const IS_LOCALHOST: boolean = !IS_PROD && !IS_STAGING && IS_DEV

// is TRUE when window is defined
export const IS_BROWSER: boolean = typeof window !== 'undefined' // Use this on SSR

// is TRUE when document is defined
export const IS_DOCUMENT: boolean = typeof document !== 'undefined'

// is TRUE when is within storybook
export const IS_STORYBOOK: boolean = !!process.env.STORYBOOK || false

// Check for CookieInformation Script
export const HAS_COOKIESOLUTION: boolean = IS_BROWSER && typeof window.CookieInformation !== 'undefined'

// id's used for the getFeedback widget
export const GETFEEDBACK_FLOW_RATING = '5d02192fefaab73dad32cbfd'
export const GETFEEDBACK_THUMBS_RATING_FORMS = '67f614ed492cc12e0962c176'
export const GETFEEDBACK_THUMBS_RATING = '5c73d5c101634d701d3482fd'
export const GETFEEDBACK_THUMBS_RATING_FLOATING_FEEDBACK = '66f2b2eab240ea50a35616f6'
export const GETFEEDBACK_WIDGET_ID = 'b29dc9281420'

// CASE-TRACE
export const SEPF_API = `https://sepf-api-gateway-${IS_PROD ? 'prod' : 'test'}.tdc.dk`
export const TRACKANDTRACE_ENDPOINT = `${SEPF_API}/openpages-tt/openpages/tracktrace/ticket`

// SIMPLE EMAIL SERVICE
export const SIMPLE_EMAIL_SERVICE_ENDPOINT = 'https://erhverv-simple-email.public.lqd.dk'

// NEWSLETTER
export const NEWSLETTER_EMAIL = 'marcomfaellesindbakkee@tdc.dk'

//SECURITY PROFILE
export const SIKKER_EMAIL = 'matlar@tdc.dk'

// Callforward form
export const CALLFORWARDING_ENDPOINT = `https://dbuc-api-gateway-${
  IS_PROD ? 'prod' : 'test'
}.public.lqd.dk/openpage/ringgratis/forwarding`

// YOUTUBE API KEY
export const YOUTUBE_API_KEY = 'AIzaSyAcQBij1E6My7kHQc9Y-UIkZ2-nlXLuuRU'

// CLUDO
export const CLUDO_API_KEY = '11ec4acd5dc54c6fab959b26bd2a3fdf'
export const CLUDO_CUSTOMER_ID = process.env.GATSBY_CLUDO_CUSTOMER_ID
export const CLUDO_ENGINE_ID = process.env.GATSBY_CLUDO_ENGINE_ID
export const CLUDO_ENGINE_ID_KUNDESERVICE = process.env.GATSBY_CLUDO_ENGINE_ID_KUNDESERVICE
export const CLUDO_HOST = 'https://api-eu1.cludo.com/api/v3'

// SALESFORCE
export const SALESFORCE_ENDPOINT = `https://${IS_PROD ? 'login' : 'test'}.salesforce.com`

//linevistation

export const LINEVISITATION_ENDPOINT = IS_PROD
  ? 'https://linevisitation.prod.business-open-pages.nuuazure.dk'
  : 'https://linevisitation.dev.business-open-pages.np-nuuazure.dk'

export const VIRK_ENDPOINT = 'http://distribution.virk.dk/cvr-permanent/_search'
